/** @format */
import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react'
import styled from 'styled-components'
import {
  _$,
  Button,
  Radio,
  Icon,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Message
} from 'kpc-react'
import {
  FilterRelationMenu,
  GroupDetailsProductFilter,
  initGroupFilter,
  FilterNameEnum,
  FilterFunctionEnum
} from './constants'
import variable from 'src/static/styles/var'
import { cloneDeep } from 'lodash'

interface ConditionMatchProps {
  className?: string
  filterRelation: 'and' | 'or'
  filters: GroupDetailsProductFilter[]
}

export interface ConditionMatchHandle {
  getValues: () => Promise<ConditionMatchProps>
}

const ConditionMatch = forwardRef<ConditionMatchHandle, ConditionMatchProps>(
  ({ className, filterRelation, filters }, ref) => {
    const [relation, setRelation] = useState<'and' | 'or'>('and')
    const [values, setValues] = useState<GroupDetailsProductFilter[]>([initGroupFilter])
    const formRef = useRef<any>()
    // 初始化
    useEffect(() => {
      filters ? setValues(filters) : setValues([initGroupFilter])
      filterRelation ? setRelation(filterRelation) : setRelation('and')
    }, [filters, filterRelation])

    // 修改匹配条件
    const changeValues = (value, index) => {
      const update = cloneDeep(values)
      update[index] = { ...update[index], ...value }
      setValues(update)
    }

    // 添加条件
    const addFilter = async () => {
      const validate = await formRef.current.validate()
      if (validate) {
        if (values.length < 10) {
          setValues([...values, { ...initGroupFilter }])
        } else {
          Message.error(_$('单个产品线最多可添加10条规则'))
        }
      }
    }

    // 删除条件
    const removeFilter = index => {
      const remove = cloneDeep(values)
      remove.splice(index, 1)
      setValues(remove)
    }

    // 导出数据
    useImperativeHandle(ref, () => ({
      getValues: async () => {
        const validate = await formRef.current.validate()
        if (validate) {
          return {
            filterRelation: relation,
            filters: values
          }
        } else {
          return undefined
        }
      }
    }))

    return (
      <div className={className}>
        <div className="header">
          <div className="left-btn">
            <Button type="primary" onClick={addFilter}>
              <Icon className="ion-plus-round" />
              {_$('添加条件')}
            </Button>
            <div className="tips">
              <Icon className="ion-information-circled" />
              <span>{_$('至多匹配1000个实例，请合理配置条件')}</span>
            </div>
          </div>
          <div className="radio-group">
            {Object.keys(FilterRelationMenu).map(key => {
              const label = FilterRelationMenu[key]
              return (
                <Radio
                  name="relation"
                  trueValue={key}
                  value={relation}
                  on$change-value={(c, value) => {
                    setRelation(value)
                  }}
                >
                  {_$(label)}
                </Radio>
              )
            })}
          </div>
        </div>
        <div className="filter">
          <Form ref={formRef} labelWidth={100}>
            {values.map(({ function: fn, name, value }, index) => {
              return (
                <Row gutter="16" align="middle">
                  <Col span="6">
                    <FormItem value={name} hideLabel={true} rules={{ required: true }}>
                      <Select
                        value={name}
                        width={180}
                        onChange={value => {
                          changeValues({ name: value }, index)
                        }}
                      >
                        {Object.keys(FilterNameEnum).map(key => {
                          const label = FilterNameEnum[key]
                          return (
                            <Option key={key} value={key}>
                              {_$(label)}
                            </Option>
                          )
                        })}
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="6">
                    <FormItem value={fn} hideLabel={true} rules={{ required: true }}>
                      <Select
                        value={fn}
                        width={180}
                        onChange={value => {
                          changeValues({ function: value }, index)
                        }}
                      >
                        {Object.keys(FilterFunctionEnum).map(key => {
                          const label = FilterFunctionEnum[key]
                          return (
                            <Option key={key} value={key}>
                              {_$(label)}
                            </Option>
                          )
                        })}
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem
                      value={value}
                      hideLabel={true}
                      rules={{ required: true, userName: true }}
                    >
                      <Input
                        value={value}
                        width={311}
                        placeholder={_$('请输入（区分大小写）')}
                        on$change-value={(_c, value) => {
                          changeValues({ value }, index)
                        }}
                      />
                    </FormItem>
                  </Col>
                  {values?.length > 1 ? (
                    <Col span="2">
                      <Icon
                        className="ion-trash-a"
                        onClick={() => {
                          removeFilter(index)
                        }}
                      />
                    </Col>
                  ) : null}
                </Row>
              )
            })}
          </Form>
        </div>
      </div>
    )
  }
)
export default styled(ConditionMatch)`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-btn {
      display: flex;
      align-items: center;
      .tips {
        display: flex;
        align-items: center;
        color: #999;
        margin-left: 8px;
        .k-icon {
          margin-right: 4px;
        }
      }
    }
  }
  .filter {
    .k-row {
      margin-top: 16px;
      .ion-trash-a {
        cursor: pointer;
        &:hover {
          color: ${variable.primaryColor};
        }
      }
    }
  }
`
